// import router from '@/app/router';
//
// const goBack = (route) => {
//   router.push({
//     name: 'dashboard',
//     query: route.query
//   });
// };

export default {
  default: {
    component: () => import(/* webpackChunkName: 'dashboard/dashboard' */ './WreDashboard'),
    routes: [
      {
        path: '',
        name: 'wre-dashboard',
        component: () => import(/* webpackChunkName: 'dashboard/dashboardMain' */ './components/DashboardMain')
      }
    ]
  }
};
